export const exportColumn = [
  {
    title: "用户名",
    key: "username"
  },
  {
    title: "头像",
    key: "avatar"
  },
  {
    title: "所属部门ID",
    key: "departmentId"
  },
  {
    title: "所属部门",
    key: "departmentTitle"
  },
  {
    title: "手机",
    key: "mobile",
    disabled: true
  },
  {
    title: "邮箱",
    key: "email"
  },
  {
    title: "性别",
    key: "sex"
  },
  {
    title: "地址",
    key: "address"
  },
  {
    title: "用户类型",
    key: "type"
  },
  {
    title: "状态",
    key: "status"
  },
  {
    title: "删除标志",
    key: "delFlag"
  },
  {
    title: "创建时间",
    key: "createTime"
  },
  {
    title: "更新时间",
    key: "updateTime"
  }
]